import { useLocation } from "react-router-dom";
import { langFromPath, pagePath, soinPath } from "./config";
import fr from "./content/fr";
import en from "./content/en";
import es from "./content/es";
import soinsFr from "./soins/fr";
import soinsEn from "./soins/en";
import soinsEs from "./soins/es";

const CONTENT = { fr, en, es };
const SOINS = { fr: soinsFr, en: soinsEn, es: soinsEs };

/** Langue courante, textes et constructeurs d'adresses localisées. */
export default function useI18n() {
    const { pathname } = useLocation();
    const lang = langFromPath(pathname);
    return {
        lang,
        t: CONTENT[lang],
        soins: SOINS[lang],
        to: (key) => pagePath(lang, key),
        toSoin: (key) => soinPath(lang, key),
    };
}

export { CONTENT, SOINS };
